// EngineHorsepower.js
import React, { useState } from "react";
import { TextField, MenuItem, Button } from "@mui/material";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,   FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
import * as yup from "yup";
import { Field, Form, Formik } from "formik";
const TITLE = "Kalkulator Tenaga Kuda Mesin - Hitung Tenaga Mesin Mobil";
const DESCRIPTION =
  "Kalkulator tenaga kuda mesin: Hitung tenaga mesin mobil atau motor Anda dengan akurat! Masukkan torsi (Newton meter) dan putaran (RPM) untuk mendapatkan tenaga kuda (HP) segera - dengan interpretasi hasil!";
const KEYWORDS =
  "kalkulator tenaga kuda mesin, menghitung tenaga kuda, estimasi tenaga kendaraan, tenaga penggerak, performa mobil";
const OG_URL = "https://do-calculate.com/calculator/id/horsepower";
const weightConversionMap = {
  pound: 1,
  ton: 2204.6226218,
  kg: 2.2046226218,
};
const timeConversionMap = {
  second: 1,
  minute: 60,
  hour: 3600,
  day: 3600 * 24,
};
const speedConversionMap = {
  "miles per hour": 1,
  "kilometers per hour": 0.6213711922,
  "meters per second": 2.236936,
};
const ETSchema = yup.object().shape({
  vehicleWeight: yup
    .number()
    .typeError("Pastikan nilai berupa angka")
    .required("Pastikan untuk memasukkan nilai")
    .max(1000000000, "Angka terlalu besar")
    .min(0, "Pastikan tidak memasukkan nilai negatif"),
  ET: yup
    .number()
    .typeError("Pastikan nilai berupa angka")
    .required("Pastikan untuk memasukkan nilai")
    .max(1000000000, "Angka terlalu besar")
    .min(0, "Pastikan tidak memasukkan nilai negatif"),
});
const initialETValues = {
  vehicleWeight: "",
  ET: "",
  vehicleWeightUnit: "pound",
  ETUnit: "second",
};
const TSSchema = yup.object().shape({
  vehicleWeight: yup
    .number()
    .typeError("Pastikan nilai berupa angka")
    .required("Pastikan untuk memasukkan nilai")
    .max(1000000000, "Angka terlalu besar")
    .min(0, "Pastikan tidak memasukkan nilai negatif"),
  TS: yup
    .number()
    .typeError("Pastikan nilai berupa angka")
    .required("Pastikan untuk memasukkan nilai")
    .max(1000000000, "Angka terlalu besar")
    .min(0, "Pastikan tidak memasukkan nilai negatif"),
});
const initialTSValues = {
  vehicleWeight: "",
  TS: "",
  vehicleWeightUnit: "pound",
  TSUnit: "miles per hour",
};
function EngineHorsepower() {
  const [horsepowerET, setHorsepowerET] = useState("");
  const onSubmitET = (values) => {
    const { vehicleWeight, ET, vehicleWeightUnit, ETUnit } = values;
    const ConversionWeight =
      vehicleWeight * weightConversionMap[vehicleWeightUnit];
    const ConversionET = ET * timeConversionMap[ETUnit];
    const factor = Math.pow(ConversionET / 5.825, 3);
    const horsepowerET = ConversionWeight / factor;
    setHorsepowerET(horsepowerET.toFixed(2));
  };
  const [horsepowerTS, setHorsepowerTS] = useState("");
  const onSubmitTS = (values) => {
    const { vehicleWeight, TS, vehicleWeightUnit, TSUnit } = values;
    const ConversionWeight =
      vehicleWeight * weightConversionMap[vehicleWeightUnit];
    const ConversionTS = TS * speedConversionMap[TSUnit];
    const factor = Math.pow(ConversionTS / 234, 3);
    const horsepowerTS = ConversionWeight * factor;
    setHorsepowerTS(horsepowerTS.toFixed(3));
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Selamat datang di Kalkulator Tenaga Kuda Mesin, alat efektif yang
                  membantu Anda menghitung dan memperkirakan tenaga mesin mobil Anda dengan mudah. Baik Anda
                  merawat performa mobil saat ini atau berpikir untuk membeli mobil baru, dapat
                  kalkulator ini memberikan statistik akurat tentang tenaga kuda mesin.
                </p>
                <h2 style={{ fontSize: "17px" }}>Cara Menggunakan Kalkulator:</h2>
                <p>
                  Menggunakan kalkulator kami sangat sederhana. Masukkan informasi utama tentang
                  mesin mobil Anda, seperti jumlah silinder, kapasitas mesin, dan torsi.
                  Setelah memasukkan data ini, kalkulator akan secara otomatis menghitung tenaga mesin
                  dalam tenaga kuda.
                </p>
                <h2 style={{ fontSize: "17px" }}>
                  Manfaat Kalkulator Tenaga Kuda Mesin:
                </h2>
                <ul>
                  <li>Memberikan perkiraan akurat performa mesin.</li>
                  <li>Pemahaman yang lebih baik tentang tenaga dan efisiensi mobil.</li>
                  <li>Membantu dalam mengambil keputusan yang lebih baik saat membeli mobil baru.</li>
                </ul>
                <p>
                  Dapatkan informasi akurat dan bermanfaat tentang tenaga mesin mobil Anda sekarang. Kunjungi
                  Kalkulator Tenaga Kuda Mesin dan hitung performa dengan mudah dan cepat!
                </p>
                <p>
                  Dua kalkulator berikut dapat digunakan untuk memperkirakan tenaga kuda mesin
                  mobil berdasarkan berat mobil, waktu yang berlalu, dan kecepatan yang digunakan
                  untuk menyelesaikan jarak seperempat mil. Berat mobil harus mencakup tidak hanya mobil,
                  tetapi juga pengemudi, penumpang, dan barang lain yang memiliki berat signifikan. Untuk memperkirakan
                  tenaga kuda maksimum, output kerja maksimum harus diterapkan dari awal hingga akhir. Hasil semua perhitungan hanyalah perkiraan.
                  <br />
                  <b>Metode Waktu Berlalu (ET):</b> Metode ini menggunakan berat
                  mobil dan waktu berlalu (ET) untuk menyelesaikan jarak seperempat mil (402.3 meter)
                  sesuai rumus berikut: <br />
                  Berat / (ET/5.825)^3 <br />
                  <b>Metode Kecepatan Perangkap:</b> Metode ini menggunakan berat kendaraan dan kecepatan
                  yang ditempuh kendaraan pada jarak seperempat mil (402.3 meter) sesuai rumus
                  berikut: <br />
                  Berat * (Kecepatan / 234)^3 <br /> Kecepatan yang digunakan harus
                  adalah kecepatan yang dicapai pada titik seperempat mil, bukan kecepatan
                  rata-rata.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <Formik
                  initialValues={initialETValues}
                  validationSchema={ETSchema}
                  onSubmit={onSubmitET}
                >
                  {(formik) => (
                    <Form>
                      <div className="mb-3">
                        <h3
                          className="p-3 mb-2 bg-success text-white"
                          style={{ fontSize: "16px", fontWeight: "bold" }}
                        >
                          Metode Waktu Berlalu (ET):
                        </h3>
                        <TextField
                          label="Berat Kendaraan"
                          name="vehicleWeight"
                          value={formik.values.vehicleWeight}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched.vehicleWeight &&
                            formik.errors.vehicleWeight
                          }
                          helperText={
                            formik.touched.vehicleWeight &&
                            formik.errors.vehicleWeight
                          }
                          sx={{
                            width: "160px",
                            ml: "10px",
                            bgcolor: "#f9f9f9",
                            "&  .MuiFormHelperText-root.Mui-error": {
                              backgroundColor: "rgb(229, 230, 227) !important",
                              margin: 0,
                              padding: "8px 0 0 41px",
                            },
                          }}
                          size="small"
                          color="success"
                        />
                        <Field
                          as={TextField}
                          select
                          name="vehicleWeightUnit"
                          value={formik.values.vehicleWeightUnit}
                          onChange={formik.handleChange}
                          size="small"
                          style={{
                            backgroundColor: "#f9f9f9",
                            pending: "5px",
                          }}
                        >
                          {Object.keys(weightConversionMap).map((unit) => (
                            <MenuItem key={unit} value={unit}>
                              {unit}
                            </MenuItem>
                          ))}
                        </Field>
                      </div>
                      <div className="mb-3">
                        <TextField
                          label="Waktu Menyelesaikan Seperempat Mil"
                          name="ET"
                          value={formik.values.ET}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={formik.touched.ET && formik.errors.ET}
                          helperText={formik.touched.ET && formik.errors.ET}
                          sx={{
                            width: "160px",
                            ml: "10px",
                            bgcolor: "#f9f9f9",
                            "&  .MuiFormHelperText-root.Mui-error": {
                              backgroundColor: "rgb(229, 230, 227) !important",
                              margin: 0,
                              padding: "8px 0 0 41px",
                            },
                          }}
                          size="small"
                          color="success"
                        />
                        <Field
                          as={TextField}
                          select
                          name="ETUnit"
                          value={formik.values.ETUnit}
                          onChange={formik.handleChange}
                          size="small"
                          style={{
                            backgroundColor: "#f9f9f9",
                            pending: "5px",
                          }}
                        >
                          {Object.keys(timeConversionMap).map((unit) => (
                            <MenuItem key={unit} value={unit}>
                              {unit}
                            </MenuItem>
                          ))}
                        </Field>
                      </div>
                      <div className="mb-3">
                        <Button
                          type="submit"
                          disabled={!formik.isValid}
                          color="success"
                          sx={{
                            backgroundColor: "rgb(25,135,84)",
                            fontSize: "15px",
                            marginRight: "25px",
                            padding: "5px 25px",
                            color: "white",
                          }}
                        >
                          Hitung
                        </Button>
                        <Button
                          disabled={!formik.isValid}
                          sx={{
                            backgroundColor: "rgb(108,117,125)",
                            fontSize: "15px",
                            marginRight: "25px",
                            padding: "5px 25px",
                            color: "white",
                          }}
                          onClick={() => {
                            formik.resetForm();
                            setHorsepowerET("");
                          }}
                        >
                          Hapus Hasil
                        </Button>
                      </div>
                      {horsepowerET &&
                        horsepowerET !== "NaN" &&
                        horsepowerET !== "Infinity" && (
                          <div
                            style={{ fontSize: "15px" }}
                            className=" bg-light  text-dark"
                          >
                            <div className="p-3 bg-success text-white mb-2">
                              <strong>
                                Hasil: Perkiraan Tenaga Mesin: {horsepowerET}{" "}
                                Horsepower{" "}
                              </strong>
                            </div>
                          </div>
                        )}
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <Formik
                  initialValues={initialTSValues}
                  validationSchema={TSSchema}
                  onSubmit={onSubmitTS}
                >
                  {(formik) => (
                    <Form>
                      <div className="mb-3">
                        <h3
                          className="p-3 mb-2 bg-success text-white"
                          style={{ fontSize: "16px", fontWeight: "bold" }}
                        >
                          Metode Kecepatan Perangkap:
                        </h3>
                        <TextField
                          label="Berat Kendaraan"
                          name="vehicleWeight"
                          value={formik.values.vehicleWeight}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched.vehicleWeight &&
                            formik.errors.vehicleWeight
                          }
                          helperText={
                            formik.touched.vehicleWeight &&
                            formik.errors.vehicleWeight
                          }
                          sx={{
                            width: "160px",
                            ml: "10px",
                            bgcolor: "#f9f9f9",
                            "&  .MuiFormHelperText-root.Mui-error": {
                              backgroundColor: "rgb(229, 230, 227) !important",
                              margin: 0,
                              padding: "8px 0 0 41px",
                            },
                          }}
                          size="small"
                          color="success"
                        />
                        <Field
                          as={TextField}
                          select
                          name="vehicleWeightUnit"
                          value={formik.values.vehicleWeightUnit}
                          onChange={formik.handleChange}
                          size="small"
                          style={{
                            backgroundColor: "#f9f9f9",
                            pending: "5px",
                          }}
                        >
                          {Object.keys(weightConversionMap).map((unit) => (
                            <MenuItem key={unit} value={unit}>
                              {unit}
                            </MenuItem>
                          ))}
                        </Field>
                      </div>
                      <div className="mb-3">
                        <TextField
                          label="Kecepatan Saat Menyelesaikan Seperempat Mil"
                          name="TS"
                          value={formik.values.TS}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={formik.touched.TS && formik.errors.TS}
                          helperText={formik.touched.TS && formik.errors.TS}
                          sx={{
                            width: "160px",
                            ml: "10px",
                            bgcolor: "#f9f9f9",
                            "&  .MuiFormHelperText-root.Mui-error": {
                              backgroundColor: "rgb(229, 230, 227) !important",
                              margin: 0,
                              padding: "8px 0 0 41px",
                            },
                          }}
                          size="small"
                          color="success"
                        />
                        <Field
                          as={TextField}
                          select
                          name="TSUnit"
                          value={formik.values.TSUnit}
                          onChange={formik.handleChange}
                          size="small"
                          style={{
                            backgroundColor: "#f9f9f9",
                            pending: "5px",
                          }}
                        >
                          {Object.keys(speedConversionMap).map((unit) => (
                            <MenuItem key={unit} value={unit}>
                              {unit}
                            </MenuItem>
                          ))}
                        </Field>
                      </div>
                      <div className="mb-3">
                        <Button
                          type="submit"
                          disabled={!formik.isValid}
                          color="success"
                          sx={{
                            backgroundColor: "rgb(25,135,84)",
                            fontSize: "15px",
                            marginRight: "25px",
                            padding: "5px 25px",
                            color: "white",
                          }}
                        >
                          Hitung
                        </Button>
                        <Button
                          disabled={!formik.isValid}
                          sx={{
                            backgroundColor: "rgb(108,117,125)",
                            fontSize: "15px",
                            marginRight: "25px",
                            padding: "5px 25px",
                            color: "white",
                          }}
                          onClick={() => {
                            formik.resetForm();
                            setHorsepowerTS("");
                          }}
                        >
                          Hapus Hasil
                        </Button>
                      </div>
                      {horsepowerTS &&
                        horsepowerTS !== "NaN" &&
                        horsepowerTS !== "Infinity" && (
                          <div
                            style={{ fontSize: "15px" }}
                            className=" bg-light  text-dark"
                          >
                            <div className="p-3 bg-success text-white mb-2">
                              <strong>
                                Hasil: Perkiraan Tenaga Mesin: {horsepowerTS}{" "}
                                Horsepower{" "}
                              </strong>
                            </div>
                          </div>
                        )}
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
            <hr />
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                Semua yang Perlu Anda Ketahui Tentang Tenaga Mesin Mobil (Tenaga Kuda):
              </div>
              <div className="info-section-body">
                <u>
                  <h2 style={{ fontSize: "16px" }}> Tindakan Pencegahan Khusus :</h2>
                </u>
                <br />
                <p>
                  Saat mengukur waktu berlalu atau kecepatan perangkap pada output kerja maksimum
                  mesin, tindakan pencegahan khusus harus diambil: <br />
                  Pertama, semua pengemudi perlu mengetahui apa yang sebenarnya mereka lakukan.
                  Kurangnya pengalaman dapat menyebabkan konsekuensi yang mungkin berbahaya dan mengancam jiwa. <br /> Kedua, jangan mengukur waktu berlalu pada jarak seperempat mil
                  di jalan umum atau jalan raya; mengemudi melebihi batas kecepatan maksimum adalah ilegal dan perhatian pengemudi harus terfokus pada mengemudi, bukan pada mengukur waktu. Aktivitas ini dapat membahayakan tidak hanya pengemudi tetapi juga orang lain. Ada tempat legal untuk mengukur waktu berlalu, seperti trek drag, jalan pedesaan milik pribadi, dan selama acara khusus yang diadakan di danau atau bandara.
                  <br /> Ketiga, pastikan kendaraan dalam kondisi kerja penuh, karena membawa kendaraan ke batas maksimumnya melibatkan risiko tertentu. Pastikan ban terisi angin dengan benar dan terpasang dengan aman, airbag berfungsi, dan mesin disetel dengan benar dan dalam kondisi baik.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>Apa itu Tenaga Kuda?</h2>
                </u>
                <br />
                <p>
                  Ide tenaga kuda diciptakan oleh insinyur abad ke-19 James Watt,
                  yang membangun beberapa mesin uap pertama. Karya Watt
                  luar biasa, dan untuk menghormatinya, namanya diberikan pada satuan daya, watt. Watt
                  bekerja di tambang, menggunakan kuda untuk menarik gerobak batu bara. Dia ingin menentukan
                  jumlah batu bara yang dapat ditarik kuda dalam gerobak dengan panjang tertentu. Dia
                  mengukur jumlah kaki yang dapat ditarik kuda seberat 22.000 pon batu bara dalam
                  satu menit. Kemudian dia meningkatkan jumlah itu menjadi 33.000 pon per menit,
                  dan menyebutnya tenaga kuda. Itu adalah jumlah yang sepenuhnya arbitrer, tetapi menjadi
                  ukuran seberapa banyak pekerjaan yang dapat dilakukan mesin, dan tidak ada yang mengukur itu sebelumnya. Jadi, bayangkan seekor kuda menarik gerobak batu bara dari tambang; dengan usaha satu tenaga kuda, kuda menarik 330 pon batu bara sejauh 100 kaki dalam satu menit.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>Mengukur Tenaga Kuda :</h2>
                </u>
                <br />
                <p>
                  Tenaga kuda diukur dengan dinamometer. Diperlukan sejumlah daya untuk membuat rotor berputar pada kecepatan tertentu. Jika Anda menempatkan mobil dalam posisi netral, lalu mengunci mesin ke tanah saat menghubungkannya ke dinamometer, perangkat memberikan beban pada mesin dan melihat apakah dapat mengatasi beban atau seberapa cepat dapat mengatasi beban. Jika Anda menjalankan mesin pada 5000 RPM (putaran per menit), Anda akan melihat berapa banyak beban yang diberikan pada dinamometer untuk menghitung tenaga kuda. Setiap mesin memiliki tenaga kuda maksimum - yaitu nilai RPM di mana daya yang tersedia dari mesin berada pada maksimum. Anda sering melihat ini dinyatakan dalam brosur atau ulasan majalah sebagai "320 tenaga kuda pada 6500 RPM".
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    Tenaga Kuda Kotor atau Bersih :
                  </h2>
                </u>
                <br />
                <p>
                  Tenaga kuda kotor adalah ukuran output kerja mesin saja pada pengukuran langsung, ketika mesin tidak terhubung ke aksesori biasa yang ada pada mobil yang berjalan. Tenaga kuda bersih mengukur output mesin saat terhubung ke aksesori yang digerakkan sabuk seperti pompa air, pompa power steering, dan generator listrik. Ada juga kehilangan aktual dalam daya yang dihasilkan dari tarikan transmisi dan slip kopling atau konverter yang dapat disesuaikan yang memperhitungkan tenaga kuda bersih. Akibat pengoperasian bagian-bagian yang bergerak ini, tenaga kuda bersih bisa jauh lebih rendah daripada tenaga kuda kotor.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    Tenaga Kuda vs Torsi :
                  </h2>
                </u>
                <br />
                <p>
                  Torsi didefinisikan sebagai gaya putar. Diukur sebagai jumlah gaya dikalikan dengan panjang tuas yang digunakan untuk bekerja. Misalnya, jika Anda menggunakan kunci pas sepanjang satu kaki untuk memberikan gaya 10 pon pada kepala baut, Anda menghasilkan torsi 10 pon-kaki. Perlu dicatat bahwa torsi diukur dalam pon-kaki, dan tenaga kuda diukur dalam kaki-pon per detik. Torsi adalah gaya yang dapat diterapkan untuk mendorong kendaraan ke depan. Dalam hal berat kendaraan tertentu, torsi tinggi berarti kendaraan dapat berakselerasi lebih cepat dan lebih responsif. Meskipun ini tidak selalu benar, secara umum, semakin besar torsi yang dihasilkan mesin, semakin besar kemampuannya untuk melakukan pekerjaan yang lebih besar. Demikian pula, mesin yang menghasilkan tenaga kuda yang lebih besar umumnya memiliki kemampuan untuk menghasilkan torsi yang lebih tinggi. Untuk memahami hubungan antara tenaga kuda dan torsi dengan lebih jelas, pikirkan perbedaan antara mobil balap dan traktor. Mobil balap ringan, sehingga tingkat tenaga kuda yang tinggi menyalurkan torsi melalui sistem roda gigi untuk membuatnya melaju kencang. Sebaliknya, traktor adalah mesin besar dan berat yang dirancang untuk melakukan pekerjaan. Traktor tidak dapat melaju kencang, tetapi sistem roda giginya menerapkan torsi sehingga dapat mendorong dan menarik. Jika Anda menempatkan mesin dengan tenaga kuda tinggi yang sama pada mobil balap dan traktor, hasilnya akan menjadi mobil balap yang cepat, tetapi bukan kendaraan yang mampu menghancurkan dinding beton. Traktor yang lambat menerapkan usahanya untuk menekan dinding dan menghancurkannya. Karena alasan ini, ketika Anda mencari spesifikasi mobil di majalah otomotif, Anda akan menemukan indikator untuk tenaga kuda dan torsi.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>Tenaga Kuda dan Performa :</h2>
                </u>
                <br />
                <p>
                  Apa yang kita sebut mobil "berperforma tinggi" hanyalah mobil dengan tenaga kuda besar dan bobot rendah; rasio daya terhadap bobot dianggap sebagai faktor utama dalam menentukan mobil berperforma tinggi. Contoh tipikal adalah mobil Ferrari, yang mungkin memiliki tenaga 800 tenaga kuda pada mobil dengan bobot 3500 pon. Ini membuat rasio daya terhadap bobot sekitar 0,229. Sebagai perbandingan, Ford Explorer, yang dijual dengan harga sekitar sepersepuluh harga Ferrari, mungkin memiliki sekitar 300 tenaga kuda untuk menggerakkan sekitar 4500 pon. Rasio daya terhadap bobot jauh lebih rendah (sekitar 0,067). Mobil Ferrari akan berakselerasi dari nol hingga 60 mil per jam jauh lebih cepat daripada Ford Explorer.
                </p>
                <hr />
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default EngineHorsepower;